import { render, staticRenderFns } from "./verifyComponent.vue?vue&type=template&id=64c2d85e&scoped=true&"
import script from "./verifyComponent.vue?vue&type=script&lang=js&"
export * from "./verifyComponent.vue?vue&type=script&lang=js&"
import style0 from "./verifyComponent.vue?vue&type=style&index=0&id=64c2d85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2d85e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VOtpInput,VRow})
